export const OFFLINE_CONNECTION_MESSAGE = 'Maaf, tidak ada koneksi internet';
export const SERVER_UNREACHABLE_MESSAGE =
  'Maaf, tidak dapat terhubung ke server. Coba lagi nanti.';

export function getAxiosNetworkFailureMessage(isOnline: boolean): string {
  if (isOnline) {
    return SERVER_UNREACHABLE_MESSAGE;
  }

  return OFFLINE_CONNECTION_MESSAGE;
}
